import React, { Component } from "react";
import { Tab, Row, Col, Nav, NavItem } from "react-bootstrap";
import "./Profile.css";
import { Auth } from "aws-amplify";
import FacebookFriend from "../components/FacebookFriend";
import { API } from "aws-amplify";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: null,
      email: null,
      userName: null,
      openFriendDetails: false,
      friendDetails: null
    };
    this.openFriendModal = this.openFriendModal.bind(this);
    this.closeFriendModal = this.closeFriendModal.bind(this);
  }

  openFriendModal(friend) {
    console.log("Popup Friend: ", friend);
    this.setState({ friendDetails: friend, openFriendModal: true });
  }

  closeFriendModal(friend) {
    console.log("Close Popup Friend: ", friend);
    this.setState({ friendDetails: null, openFriendModal: false });
  }
  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }
    try {
      const user = await this.GetUserProfile();
      console.log("Searched user");
      this.setState({ user });
    } catch (e) {
      alert(e);
    }
  }

  requestConnection = function(data) {
    console.log("requestConnection: ", data);
    API.post("books", "user/addfriend", {
      body: { friendID: "FB" + data.id }
    }).then(response => {
      console.log("response: ", response);
      this.setState({ addMessage: "Connection request sent." });
      setTimeout(
        function() {
          this.closeFriendModal();
        }.bind(this),
        3000
      );
    });

    return;
  };

  GetUserProfile = () => {
    console.log("Obtaining user.");
    var result;
    // var self = this;
    Auth.currentAuthenticatedUser()
      .then(data => {
        console.log("User returned:", data);
        result = data;
        this.setState({ userName: data.name, email: data.email });
      })
      .catch(err => console.log("GetUserProfile", err));

    return result;
  };

  editProfile = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    this.props.history.push("profile/edit");

    this.setState({ isLoading: false });
  };

  openLibrary = async event => {
    this.props.history.push("/user/library");
  };

  async openFriend(id) {
    this.props.history.push("/friend/" + id);
  }

  renderProfile() {
    let friendList;

    let friends = JSON.parse(localStorage.getItem("friendList"));
    // if (!friends) {
    //   window.FB.api("/me/friends?fields=name,email,picture", async response => {
    //     console.log("FB Me inside handleResponse:", response);
    //     friends = response.data;
    //   });
    // }
    console.log("Friends", friends);
    friendList = (
      <ul className="list-group">
        {" "}
        {friends
          ? friends.map((Friend, i) => {
              return (
                <FacebookFriend
                  key={i}
                  src={Friend}
                  onClick={() => {
                    this.openFriendModal(Friend);
                  }}
                  onFriendRequest={() => {
                    this.requestConnection(Friend);
                  }}
                />
              );
            })
          : ""}
      </ul>
    );

    return (
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row className="clearfix">
          <Col sm={2}>
            <Nav bsStyle="pills" stacked>
              <NavItem eventKey="first">Profile</NavItem>
              <NavItem eventKey="second">Preferences</NavItem>
              <NavItem eventKey="third">Friends</NavItem>
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content animation>
              <Tab.Pane eventKey="first">
                <p>
                  Name: <input type="text" value={this.state.userName} />
                </p>
                <p>
                  Email: <input type="text" value={this.state.email} />
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="second">Tab 2 content</Tab.Pane>
              <Tab.Pane eventKey="third">{friendList}</Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }

  render() {
    return <div className="Profile">{this.renderProfile()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Profile.js